// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeUnit_home-unit__EvqBo {
  display: flex;
  padding: 100px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  background: var(--background-color-1);
  overflow-x: hidden;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--title__S\\+pxD {
  color: var(--accent-color);
  font-size: 32px;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--title__S\\+pxD a {
  color: var(--accent-color);
  font-weight: 700;
  text-decoration: underline;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--swiper__SoQ6V .swiper-wrapper {
  margin: 14px 0;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--swiper--slide__EDPNH {
  width: 320px !important;
  height: initial !important;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--button__UofLI {
  background-color: var(--accent-color);
  text-transform: initial;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--button__wrapper__ITFXw {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
}
.HomeUnit_home-unit__EvqBo .HomeUnit_home-unit--button__UofLI svg {
  fill: white;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeUnit/HomeUnit.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;AACF;AAEI;EACE,0BAAA;EACA,eAAA;AAAN;AACM;EACE,0BAAA;EACA,gBAAA;EACA,0BAAA;AACR;AAIM;EACE,cAAA;AAFR;AAIM;EACE,uBAAA;EACA,0BAAA;AAFR;AAMI;EACE,qCAAA;EACA,uBAAA;AAJN;AAMM;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAOM;EACE,WAAA;AALR","sourcesContent":[".home-unit {\n  display: flex;\n  padding: 100px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  align-self: stretch;\n  background: var(--background-color-1);\n  overflow-x: hidden;\n\n  .home-unit {\n    &--title {\n      color: var(--accent-color);\n      font-size: 32px;\n      a {\n        color: var(--accent-color);\n        font-weight: 700;\n        text-decoration: underline;\n      }\n    }\n\n    &--swiper {\n      :global(.swiper-wrapper) {\n        margin: 14px 0;\n      }\n      &--slide {\n        width: 320px !important;\n        height: initial !important;\n      }\n    }\n\n    &--button {\n      background-color: var(--accent-color);\n      text-transform: initial;\n\n      &__wrapper {\n        display: flex;\n        justify-content: flex-end;\n        align-items: flex-start;\n        align-self: stretch;\n      }\n\n      svg {\n        fill: white;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-unit": `HomeUnit_home-unit__EvqBo`,
	"home-unit--title": `HomeUnit_home-unit--title__S+pxD`,
	"home-unit--swiper": `HomeUnit_home-unit--swiper__SoQ6V`,
	"home-unit--swiper--slide": `HomeUnit_home-unit--swiper--slide__EDPNH`,
	"home-unit--button": `HomeUnit_home-unit--button__UofLI`,
	"home-unit--button__wrapper": `HomeUnit_home-unit--button__wrapper__ITFXw`
};
export default ___CSS_LOADER_EXPORT___;
